// extracted by css-extract-rspack-plugin
export default {"cls1":"memory_ladder-cls1_M_2","cls2":"memory_ladder-cls2_B-v memory_ladder-cls1_M_2"};